import { DropDownOption } from "../interfaces/drop-down-option.interface";

const RATE_CALCULATION_METHOD_ITEMS: DropDownOption[] = [{
    id: 'COMPOUNDING', displayValue: 'Compounding'
  }];

const RATE_BUSINESS_DAYS_OPTIONS: DropDownOption[] = [
    { id: '0B', displayValue: 'None' },
    { id: '1B', displayValue: '1B' },
    { id: '2B', displayValue: '2B' },
    { id: '3B', displayValue: '3B' },
    { id: '4B', displayValue: '4B' },
    { id: '5B', displayValue: '5B' },
    { id: '10B', displayValue: '10B' },
];

const RATE_SUSPENSION_PERIODS_OPTIONS: DropDownOption[] = [
    { id: 1, displayValue: 'None' },
    { id: 2, displayValue: '2' },
    { id: 3, displayValue: '3' },
    { id: 4, displayValue: '4' },
    { id: 5, displayValue: '5' },
    { id: 10, displayValue: '10' },
];

export const RateOptions = {
    CALCULATION_METHOD: RATE_CALCULATION_METHOD_ITEMS,
    BUSINESS_DAYS: RATE_BUSINESS_DAYS_OPTIONS,
    SUSPENSION_PERIODS: RATE_SUSPENSION_PERIODS_OPTIONS
};

